<template>
    <div class="myPage93" v-show="showWin">
        <div class="myContent m_width m_mar0a m_flex m_aic m_jcsb">
            <div class="leftBox m_flex m_aic m_jcs">
                <div class="item m_flex m_ais m_jcsb active" v-if="vuex_compare_popup_list[0]">
                    <div class="lBox">
                        <img :src="vuex_compare_popup_list[0].thumb ? vuex_compare_popup_list[0].thumb : vuex_default_img" class="img" alt="" />
                    </div>
                    <div class="rBox">
                        <div class="title m_line_1">{{ vuex_compare_popup_list[0].subtitle }}</div>
                        <div class="redText" @click="goDetail(vuex_compare_popup_list[0])">{{ vuex_compare_popup_list[0].zSn }}</div>
                        <div class="blackText m_line_3">
                            {{ vuex_compare_popup_list[0].title }}
                        </div>
                    </div>
                    <div class="delBtn m_flex m_aic m_jcc" @click="delFun(0)">
                        <img src="@/assets/images/del.png" class="del" alt="" />
                    </div>
                </div>
                <div class="item m_flex m_ais m_jcsb" v-else></div>

                <div class="item m_flex m_ais m_jcsb active" v-if="vuex_compare_popup_list[1]">
                    <div class="lBox">
                        <img :src="vuex_compare_popup_list[1].thumb ? vuex_compare_popup_list[1].thumb : vuex_default_img" class="img" alt="" />
                    </div>
                    <div class="rBox">
                        <div class="title m_line_1">{{ vuex_compare_popup_list[1].subtitle }}</div>
                        <div class="redText" @click="goDetail(vuex_compare_popup_list[1])">{{ vuex_compare_popup_list[1].zSn }}</div>
                        <div class="blackText m_line_3">
                            {{ vuex_compare_popup_list[1].title }}
                        </div>
                    </div>
                    <div class="delBtn m_flex m_aic m_jcc" @click="delFun(1)">
                        <img src="@/assets/images/del.png" class="del" alt="" />
                    </div>
                </div>
                <div class="item m_flex m_ais m_jcsb" v-else></div>

                <div class="item m_flex m_ais m_jcsb active" v-if="vuex_compare_popup_list[2]">
                    <div class="lBox">
                        <img :src="vuex_compare_popup_list[2].thumb ? vuex_compare_popup_list[2].thumb : vuex_default_img" class="img" alt="" />
                    </div>
                    <div class="rBox">
                        <div class="title m_line_1">{{ vuex_compare_popup_list[2].subtitle }}</div>
                        <div class="redText" @click="goDetail(vuex_compare_popup_list[2])">{{ vuex_compare_popup_list[2].zSn }}</div>
                        <div class="blackText m_line_3">
                            {{ vuex_compare_popup_list[2].title }}
                        </div>
                    </div>
                    <div class="delBtn m_flex m_aic m_jcc" @click="delFun(2)">
                        <img src="@/assets/images/del.png" class="del" alt="" />
                    </div>
                </div>
                <div class="item m_flex m_ais m_jcsb" v-else></div>

                <div class="item m_flex m_ais m_jcsb active" v-if="vuex_compare_popup_list[3]">
                    <div class="lBox">
                        <img :src="vuex_compare_popup_list[3].thumb ? vuex_compare_popup_list[3].thumb : vuex_default_img" class="img" alt="" />
                    </div>
                    <div class="rBox">
                        <div class="title m_line_1">{{ vuex_compare_popup_list[3].subtitle }}</div>
                        <div class="redText" @click="goDetail(vuex_compare_popup_list[3])">{{ vuex_compare_popup_list[3].zSn }}</div>
                        <div class="blackText m_line_3">
                            {{ vuex_compare_popup_list[3].title }}
                        </div>
                    </div>
                    <div class="delBtn m_flex m_aic m_jcc" @click="delFun(3)">
                        <img src="@/assets/images/del.png" class="del" alt="" />
                    </div>
                </div>
                <div class="item m_flex m_ais m_jcsb" v-else></div>
            </div>
            <div class="rightBox m_flex m_aic m_jcsb">
                <div class="compareBtn btn-ripple m_flex m_aic m_jcc" @click="goCompare">比较</div>
                <div class="delBigBox">
                    <div class="delText" @click="delAll">全部清除</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showWin: false,

            canShowPath: ['/products', '/search-result'], // 可以显示的路由
        }
    },
    watch: {
        vuex_compare_popup_list: {
            immediate: true,
            deep: true,
            handler(newV) {
                if (this.$route.path == '/search-result' && this.$route.query.type != 1) {
                    this.showWin = false
                    return
                }

                if (this.isValueInArray(this.canShowPath, this.$route.path)) {
                    if (this.vuex_compare_popup_list.length > 0) {
                        this.showWin = true
                    } else {
                        this.showWin = false
                    }
                } else {
                    this.showWin = false
                }
            },
        },
        $route: {
            immediate: true,
            deep: true,
            handler(newV) {
                if (this.$route.path == '/search-result' && this.$route.query.type != 1) {
                    this.showWin = false
                    return
                }

                if (this.isValueInArray(this.canShowPath, this.$route.path)) {
                    if (this.vuex_compare_popup_list.length > 0) {
                        this.showWin = true
                    } else {
                        this.showWin = false
                    }
                } else {
                    this.showWin = false
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        isValueInArray(arr, value) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] == value) {
                    return true
                }
            }
            return false
        },
        goCompare() {
            this.mix_setVuex('vuex_compare_popup_list_detail', [])
            this.$router.push({
                path: '/compare',
            })
        },
        goDetail(item) {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: item.inventoryId,
                },
            })
        },
        delAll() {
            this.mix_setVuex('vuex_compare_popup_list', [])
        },
        delFun(index) {
            let vuex_compare_popup_list = this.$cloneDeep(this.vuex_compare_popup_list)
            vuex_compare_popup_list.splice(index, 1)
            this.mix_setVuex('vuex_compare_popup_list', vuex_compare_popup_list)
        },
    },
}
</script>

<style lang="less" scoped>
.myPage93 {
    width: 100%;
    height: 152px;
    background: #f8f8fc;
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 99;
    padding: 18px 0;

    .myContent {
        height: 100%;

        .leftBox {
            width: calc(100% - 244px - 18px);
            height: 100%;

            .item {
                width: calc((100% - 16px * 3) / 4);
                height: 100%;
                margin-right: 16px;
                position: relative;
                padding: 16px;

                &:nth-child(4n) {
                    margin-right: 0;
                }

                background: #e0e0e2;
                border-radius: 5px 5px 5px 5px;
                border: 1px solid #c9c9c9;

                .delBtn {
                    width: 25px;
                    height: 25px;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    cursor: pointer;

                    .del {
                        width: 13px;
                        height: 13px;
                    }
                }

                &.active {
                    background: #ffffff;
                }

                .lBox {
                    width: 58px;
                    height: 58px;
                    background: #ffffff;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #c9c9c9;

                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .rBox {
                    width: calc(100% - 58px - 8px);

                    .title {
                        width: calc(100% - 30px);
                        font-weight: bold;
                        font-size: 12px;
                        color: #000000;
                        line-height: 18px;
                        text-align: left;
                    }

                    .redText {
                        width: 85%;
                        cursor: pointer;
                        font-weight: bold;
                        font-size: 14px;
                        color: #d61818;
                        line-height: 20px;
                        text-align: left;
                    }

                    .blackText {
                        width: 100%;
                        font-weight: bold;
                        font-size: 12px;
                        color: #000000;
                        line-height: 18px;
                        text-align: left;
                    }
                }
            }
        }

        .rightBox {
            width: 244px;
            height: 100%;

            .compareBtn {
                width: 144px;
                height: 40px;
                border-radius: 5px 5px 5px 5px;
                border: 1px solid #d61818;
                font-weight: bold;
                font-size: 14px;
                color: #d61818;
                line-height: 24px;
                text-align: left;
            }

            .delBigBox {
                width: 60px;
                height: 100%;

                .delText {
                    cursor: pointer;
                    width: 100%;
                    font-weight: bold;
                    font-size: 14px;
                    color: #d61818;
                    line-height: 20px;
                    text-align: right;
                }
            }
        }
    }
}
</style>
<style lang="less" scoped src="./style/h5-compare-win.less"></style>
